import React, { Component } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import $ from 'jquery';
import config from '../../../config.json';
import { PtInput, PtDateInput } from '../../../grit-utilities';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
// npm i react-image-crop@7.0.2 --legacy-peer-deps

const galleryThumbnail = {
    width: "330px",
    height: "300px",
    marginTop: '10px',
    marginBottom: '10px'
}

const txtStyle = {
    fontSize: "15px",
    fontWeight: "bold",
    marginTop: "15px"
}

export default class SignPhotoGallery extends Component {

    constructor(props) {
        super(props)
        const { pointModel } = this.props;
        this.state =
        {
            galleryModel: pointModel.galleryModel,
            selectedIndex: 0,
            nextBtndisable: false,
            prevBtndisable: false,
            commentArr: pointModel.galleryModel.Comments,
            layer: this.props.pointModel.layer,
            agencyId: this.props.pointModel.agencyId,
            comment: this.props.pointModel.galleryModel.Comments && this.props.pointModel.galleryModel.Comments.length > 0 ? this.props.pointModel.galleryModel.Comments[0] : '',
            src: null,
            crop: {
                x: 20,
                y: 5,
                width: 200,
                height: 180
            },
            croppedImageUrl: ''
        }

        if (this.state.galleryModel.datecreated && this.state.galleryModel.datecreated.length > 0 && this.state.galleryModel.datecreated[0]) {
            this.state.printDate = this.state.galleryModel.datecreated[0].slice(0, 10);
        } else {
            this.state.printDate = null;
        }

        if (!this.state.galleryModel.photos || this.state.galleryModel.photos.length == 0) { this.state.galleryModel.photos = [] }
    }

    componentDidUpdate() {
        this.props.pointModel.galleryModel = this.state.galleryModel;
    }

    onImageLoaded = (image) => {
        this.imageRef = image;
    };

    onChange = (crop) => {
        this.setState({ crop });
    }

    onCropComplete = (crop) => {
        this.makeClientCrop(crop);
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                'newFile.png'
            );
            croppedImageUrl &&
                this.setState({ croppedImageUrl });
        }
    }

    async fetchImageAsBase64(url) {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    captureScreenshot = () => {
        const streetViewMapUrl = sessionStorage.getItem('streetViewMapUrl');
        if (streetViewMapUrl) {
            this.fetchImageAsBase64(streetViewMapUrl)
                .then(base64 => {
                    this.setState({
                        src: base64, croppedImageUrl: '', crop: {
                            x: 20,
                            y: 5,
                            width: 200,
                            height: 180
                        }
                    });
                })
                .catch(error => console.error('Error fetching image:', error));
        }
    };

    uploadScreenshot = () => {
        if (this.state.croppedImageUrl) {
            if (this.props.pointModel && this.props.pointModel.Support && this.props.pointModel.Support.SignId) {
                fetch(this.state.croppedImageUrl)
                    .then(res => res.blob())
                    .then(blob => {
                        var time = Date.now();
                        var month = new Date().getMonth()
                        var date = new Date().getDate()
                        var year = new Date().getFullYear()

                        const single_file = new File([blob], 'selectedFile', { type: 'image/jpeg' });
                        let renamed_file = this.renameFile(single_file,
                            this.props.pointModel.Support.SignId + "_" + this.props.pointModel.layer + "_" + month + "_" + date + "_" + year + "_" + time + ".jpg");

                        const formData = new FormData();
                        formData.append('selectedFile', renamed_file);
                        this.uploadAPICall(formData);
                    })
                    .catch(error => {
                        console.error('Error in converting cropped image to Blob:', error);
                    });
            } else {
                alert('Please upload images after saving new points.');
            }
        } else {
            alert('No cropped image found.');
        }
    };


    getCroppedImg(image, crop, fileName) {
        image.setAttribute('crossorigin', 'anonymous');
        const canvas = document.createElement('canvas');
        const pixelRatio = window.devicePixelRatio;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        return new Promise((resolve, reject) => {
            requestAnimationFrame(() => {
                ctx.drawImage(
                    image,
                    crop.x * scaleX,
                    crop.y * scaleY,
                    crop.width * scaleX,
                    crop.height * scaleY,
                    0,
                    0,
                    crop.width * scaleX,
                    crop.height * scaleY
                );

                canvas.toBlob(
                    (blob) => {
                        if (!blob) {
                            this.getCroppedImg(image, crop, fileName);
                            return;
                        }
                        blob.name = fileName;
                        window.URL.revokeObjectURL(this.fileUrl);
                        this.fileUrl = window.URL.createObjectURL(blob);
                        resolve(this.fileUrl);
                        this.setState({ croppedImageUrl: this.fileUrl });
                    },
                    'image/png',
                    1
                );
            });
        });
    }


    setWebcamRef = element => {
        this.webcam = element;
    }

    setHiddenFileInputRef = element => {
        this.hiddenFileInput = element;
    }

    renameFile = (originalFile, newName) => {
        return new File([originalFile], newName, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
        });
    }

    uploadFileButtonClick = e => {
        document.getElementById('photo_input').click();
    }

    handleFileChange = e => {

        const { name } = e.target
        this.setState({ [name]: e.target.files[0] });
        var data = new FormData();

        // have to get time now and increment in for loop so as to ensure each iteration has unique time 
        // (sometimes it's too speedy and files get same name)
        var time = Date.now();
        var month = new Date().getMonth()
        var date = new Date().getDate()
        var year = new Date().getFullYear()

        if (this.props.pointModel && this.props.pointModel.Support && this.props.pointModel.Support.SignId) {
            for (const single_file of e.target.files) {

                if (single_file.type == "image/jpeg") {
                    // have to make copy with new name because files are immutable for security (agencyID_markerID_time.jpg)
                    let renamed_file = this.renameFile(single_file,
                        this.props.pointModel.Support.SignId + "_" + this.props.pointModel.layer + "_" + month + "_" + date + "_" + year + "_" + time + ".jpg");
                    time += 5;
                    data.append(e.target.name, renamed_file);
                } else {
                    alert("File type must be jpg. This file is not added: " + single_file.name);
                }
            }
        } else {
            alert('Please upload images after saving new points.');
        }

        // when done is false, there are entries
        let dataIsNotEmpty = !(data.entries().next().done);

        if (dataIsNotEmpty) {
            this.uploadAPICall(data);
        } else {
            console.log("Zero valid files selected. Ensure to select only jpeg images.");
        }

    }

    uploadAPICall(data) {
        $.ajax({
            type: "POST",
            url: `${config.server}/upload/signsphotogal`, // /files?
            data: data,
            processData: false,
            contentType: false,

            success: (response) => {
                if (response['message'] === "Uploaded") {
                    this.loadPhotos(this.state.galleryModel.photos.length);
                    this.setState({ croppedImageUrl: '', src: null });
                    alert('Image have been saved successfully!')
                }
            },
            error: (error) => {
                alert('Error: Failed to save images')
                console.log(error)
            }
        });
    }

    next = () => {
        if (this.state.selectedIndex === this.state.galleryModel.photos.length - 1)
            this.setState({ nextBtndisable: true })
        else {
            let index = this.state.selectedIndex + 1
            this.setState({ selectedIndex: index, nextBtndisable: false, prevBtndisable: false, comment: this.props.pointModel.galleryModel.Comments[index] })

            if (this.props.pointModel.galleryModel.datecreated[index]) {
                this.setState({ printDate: this.props.pointModel.galleryModel.datecreated[index].slice(0, 10) });
            } else {
                this.setState({ printDate: null });
            }
        }
    }

    previous = () => {
        if (this.state.selectedIndex === 0)
            this.setState({ prevBtndisable: true })
        else {
            let index = this.state.selectedIndex - 1;
            this.setState({ selectedIndex: index, prevBtndisable: false, nextBtndisable: false, comment: this.props.pointModel.galleryModel.Comments[index] })

            if (this.props.pointModel.galleryModel.datecreated[index]) {
                this.setState({ printDate: this.props.pointModel.galleryModel.datecreated[index].slice(0, 10) });
            } else {
                this.setState({ printDate: null });
            }
        }
    }

    deletePhoto = () => {
        this.props.showLoadingSpinner(true)
        let name = this.state.galleryModel.photos[this.state.selectedIndex].split('/')

        let finalData = {
            photoKey: this.state.galleryModel.key[this.state.selectedIndex],
            photoPath: this.state.galleryModel.photos[this.state.selectedIndex],
            photoName: name[name.length - 1]
        };

        $.ajax({
            type: 'POST',
            url: `${config.server}\\deletesignsphoto`,
            contentType: 'application/json',
            data: JSON.stringify(finalData),

            success: (data) => {
                this.props.showLoadingSpinner(false);
                this.loadPhotos(0);
                alert('Image deleted successfully!')
            },
            error: (error) => {
                this.props.showLoadingSpinner(false);
                alert('Error: Failed to delete images')
                console.log(error)
            }
        });
    }

    saveComment = () => {

        let finalData = {
            photoKey: this.state.galleryModel.key[this.state.selectedIndex],
            commentList: this.state.comment,
            date: this.state.galleryModel.datecreated[this.state.selectedIndex]
        };

        $.ajax({
            type: 'POST',
            url: `${config.server}\\savesignphotocomment`,
            contentType: 'application/json',
            data: JSON.stringify(finalData),
            success: (data) => {

                if (data['message'] === "OK") {
                    this.loadPhotos(this.state.selectedIndex);
                    alert('Comments have been saved successfully!')
                }

            },
        });
    }

    loadPhotos(index = 0) {
        let signId = this.props.pointModel.Support ? this.props.pointModel.Support.SignId : 0;
        $.ajax({
            type: 'GET',
            url: `${config.server}\\signsphotos\\${signId}`,
            contentType: 'application/json',
            success: (data) => {
                this.setState(
                    {

                        galleryModel: data.galleryModel,
                        selectedIndex: index,
                        nextBtndisable: false,
                        prevBtndisable: false,
                        commentArr: data.galleryModel.Comments,
                        comment: data.galleryModel.Comments && data.galleryModel.Comments.length && data.galleryModel.Comments.length > index ? data.galleryModel.Comments[index] : '',
                    });

                if (data.galleryModel.datecreated && data.galleryModel.datecreated.length && data.galleryModel.datecreated.length > index && data.galleryModel.datecreated[index]) {
                    this.setState({ printDate: data.galleryModel.datecreated[index].slice(0, 10) });
                } else {
                    this.setState({ printDate: null });
                }

                if (!data.galleryModel.photos || data.galleryModel.photos.length == 0) {
                    let galleryModel = this.state.galleryModel;
                    galleryModel.photos = [];
                    this.setState({ galleryModel: galleryModel });
                }
            },
        });
    }

    onUpdateItems = (e) => {
        const { name, value } = e.target
        this.setState({ [name]: value })

    };

    onChangeDate = (date, name) => {
        if (date instanceof Date && !isNaN(date)) {
            this.setState({ selectedIndex: this.state.selectedIndex })
            this.state.galleryModel.datecreated[this.state.selectedIndex] = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
            this.state.printDate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
        }
    }

    render() {
        // the button works to allow uploading or camera image(on mobile) so display text based off of device.
        const buttonText = window.mobileAndTabletcheck() ? "Take photo or Upload Photos from Device" : "Upload Photos from Device";
        return (
            <div id="root">

                <form id="frmUploader" encType="multipart/form-data" action="/upload/ms_photogal" method="post">
                    <input id="photo_input" name="selectedFile" type="file" onChange={this.handleFileChange} ref={this.setHiddenFileInputRef}
                        style={{ display: 'none' }} accepts="image/jpeg" multiple />
                </form>

                {this.state.galleryModel.photos.length > 0 &&
                    <img style={galleryThumbnail} src={this.state.galleryModel.photos[this.state.selectedIndex]} />}

                {<Grid style={{ marginBottom: "5px" }}>
                    <Grid.Column>
                        {!this.props.pointModel.FlagForGallery &&
                            <Button size='small' onClick={this.uploadFileButtonClick} color='green' style={{ marginTop: "10px" }} disabled={this.props.disabled}>{buttonText}</Button>
                        }

                        {
                            <Button size='small' onClick={this.captureScreenshot} color='green' style={{ marginTop: "10px" }} disabled={this.props.disabled}>Clip Photo</Button>
                        }

                        {this.state.galleryModel.photos.length === 0 && this.props.pointModel.FlagForGallery &&
                            <p style={{ marginTop: "10px", textAlign: "center", color: "red" }}> Please First Save the Sign to use the Gallery Tab</p>
                        }
                    </Grid.Column>
                </Grid>}

                {this.state.src &&
                    <ReactCrop src={this.state.src}
                        crop={this.state.crop}
                        onChange={this.onChange}
                        onImageLoaded={this.onImageLoaded}
                        onComplete={this.onCropComplete} />
                }

                {this.state.croppedImageUrl && (
                    <img alt="Crop" style={{ maxWidth: '100%' }} src={this.state.croppedImageUrl} />
                )}

                {this.state.croppedImageUrl && (
                    <Button size='small' onClick={this.uploadScreenshot} color='green' style={{ marginTop: "10px" }} disabled={this.props.disabled}>Upload Cliped Photo</Button>
                )}

                {
                    this.state.galleryModel.photos.length > 0 &&
                    <PtInput type="text" label="Comment"
                        value={this.state.comment ? this.state.comment : ''}
                        onChange={this.onUpdateItems} name="comment" disabled={this.props.disabled} />
                }

                {this.state.galleryModel.photos.length > 0 &&
                    <PtDateInput label='Date Taken' placeholder="Not Available" minDate={new Date(1900, 0, 1)}
                        inputType="hwy" name="CreatedDate" disabled={this.props.disabled}
                        value={this.state.printDate ? this.state.printDate : null}
                        onChange={(date) => this.onChangeDate(date, "CreatedDate")} />}

                {this.state.galleryModel.photos.length > 0 &&
                    <Button color="green" disabled={this.props.disabled} onClick={() => this.saveComment()} >Save Comment and Date</Button>}

                {this.state.galleryModel.photos.length === 0 && !this.props.pointModel.FlagForGallery && !this.state.croppedImageUrl && !this.state.src &&
                    <p style={{ marginTop: "10px", textAlign: "center", color: "red" }}> No Images Available for this Sign.</p>}

                {this.state.galleryModel.photos.length > 0 &&
                    <p style={txtStyle}>Image {this.state.selectedIndex + 1}/{this.state.galleryModel.photos.length}</p>}

                {this.state.galleryModel.photos.length > 0 &&
                    <Button disabled={this.state.prevBtndisable} onClick={() => this.previous()}>Previous</Button>}

                {this.state.galleryModel.photos.length > 0 &&
                    <Button disabled={this.state.nextBtndisable} onClick={() => this.next()} >Next</Button>}

                {this.state.galleryModel.photos.length > 0 &&
                    <Button color="teal" disabled={this.props.disabled} onClick={() => this.deletePhoto()} >Delete Photo</Button>}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/layers/tabs/sign/photogallery.js